import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { FormControl, Radio } from "@mui/material";

class LogisticReportViewPanelControl extends Component {
  render() {
    const { onSetViewPanel, viewPanel, viewPanelItems } = this.props;
    return (
      <div >
        <FormControl>
          <div className={styles.radioButtomContainer}>
            <div
              className={styles.radioButtomItem}
              onClick={() => {
                onSetViewPanel(viewPanelItems.controPointReports);
              }}
            >
              <Radio checked={viewPanel === viewPanelItems.controPointReports} size="small" />
              Контрольные точки
            </div>

            <div
              className={styles.radioButtomItem}
              onClick={() => {
                onSetViewPanel(viewPanelItems.taskTripReports);
              }}
            >
              <Radio checked={viewPanel === viewPanelItems.taskTripReports} size="small" />
             Рейсы
            </div>
          </div>
        </FormControl>
      </div>
    );
  }
}

export default React.memo(LogisticReportViewPanelControl);
